// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__10B4s","gfeWrapper":"CalendarEvent_gfeWrapper__3Oo2H"};